import { mcn, type BaseProps } from "@/utils/baseProps.ts";
import type { ReactNode } from "react";

export interface SectionHeaderProps extends BaseProps {
    title: ReactNode;
    /** Lead paragraph below the heading. */
    description?: ReactNode;
    /** Extra items to the right of the heading */
    children?: ReactNode;
}

/**
 * Heading (with an optional description) for a section of page content.
 * Rendered as the first child of the section container (usually a `ContentPane`).
 */
export function SectionHeader({ title, description, children, ...props }: SectionHeaderProps) {
    return (
        <header {...mcn("VStack gap-4 color-muted", props)}>
            <div className="flex flex-wrap gap-4 items-baseline">
                <h2 className="font-size-subtitle color-text">{title}</h2>
                {children}
            </div>
            {!!description && <div>{description}</div>}
        </header>
    );
}
